"use client";

import dynamic from "next/dynamic";

const AppReferralInviteModal = dynamic(
  () =>
    import("modules/city/components/client/AppReferralInviteModal").then(
      (mod) => mod.AppReferralInviteModal
    ),
  { ssr: false }
);

export default function DynamicAppReferralInviteModal() {
  return <AppReferralInviteModal />;
}
